// extracted by mini-css-extract-plugin
export default {"recipientIcon":"style_recipientIcon__6jgsH"};